import { jsx as _jsx } from "react/jsx-runtime";
import { GenericMask } from '@cmd/ui-components';
import { Spinner } from '@interstate/components/Spinner';
import { Typography } from '@interstate/components/Typography';
const WebComponentTileMask = ({ error, isLoading, noData, size, }) => {
    const typeSizeVariant = size === 'large'
        ? 'body-lg'
        : (size === 'xsmall' ? 'body-sm' : 'body-md');
    return (isLoading || error || noData) && (_jsx(GenericMask, { children: error
            ? _jsx(Typography, { variant: typeSizeVariant, children: "Unable to load data" })
            : (isLoading
                ? _jsx(Spinner, {})
                : _jsx(Typography, { variant: typeSizeVariant, children: "No Data to Display" })) }));
};
export default WebComponentTileMask;
